import { Badge } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { TagSelect } from '@hero/molecules';

import * as S from './style';

export function ColumnTagSelect({ readOnly, isFocused, onChange, ...props }) {
  const ref = useRef();
  const { t } = useTranslation();

  const { value, onBlur, onFocus } = props;

  const isTagSelectShown = isFocused && !readOnly;

  function TagSelectButtonWithBadge() {
    return (
      <S.TagSelectButton
        onClick={() => {
          if (!readOnly) onFocus();
        }}
      >
        {value?.slice(0, 2).map(tag => (
          <Badge color="bgWeak" variant="contained" key={tag.value} size="sm" rounded>
            {tag.label}
          </Badge>
        ))}
        <S.MoreText>{value?.length - 2 > 0 && `+${value?.length - 2} more`}</S.MoreText>
      </S.TagSelectButton>
    );
  }

  function TagSelectButtonWithPlaceholder() {
    return (
      <S.TagSelectButton
        onClick={() => {
          if (!readOnly) onFocus();
        }}
      >
        <S.Placeholder>{readOnly ? '-' : t('createOrFindATag')}</S.Placeholder>
      </S.TagSelectButton>
    );
  }

  const TagSelectButton = () =>
    value?.length > 0 ? TagSelectButtonWithBadge() : TagSelectButtonWithPlaceholder();

  useEffect(() => {
    if (isFocused) {
      ref.current.focus();
    }
  }, [isFocused]);

  return (
    <S.TagWrapper isFocused={isFocused} readOnly={readOnly}>
      {isTagSelectShown ? (
        <TagSelect
          ref={ref}
          onChange={val => {
            onChange(undefined, val);
          }}
          onApply={onBlur}
          {...props}
          onBlur={() => {}}
          onFocus={() => {}}
          menuIsOpen
          styles={{
            control: provided => {
              return {
                ...provided,
                padding: '5px 15px',
                borderWidth: isFocused ? 1 : 0,
                maxWidth: isFocused ? '450px' : 'auto',
                height: isFocused ? 'auto' : '40px',
                overflowY: 'hidden',
                overflowX: isFocused ? 'hidden' : 'auto'
              };
            },
            valueContainer: provided => {
              return {
                ...provided,
                maxWidth: isFocused ? '450px' : 'auto'
              };
            }
          }}
        />
      ) : (
        <TagSelectButton />
      )}
    </S.TagWrapper>
  );
}

ColumnTagSelect.propTypes = {
  readOnly: PropTypes.bool,
  isFocused: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onBlur: PropTypes.func,
  onFocus: PropTypes.func
};
